// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39Vr_","col":"styles_col__25kW8"};